import React from 'react'

import {css} from '../../theme/css'
import {createSvgIcon} from '../utils'

const root = css`
  block-size: 32px;
  inline-size: 32px;
`

export default createSvgIcon(
  <>
    <mask
      height="32"
      id="mask0_14108_160427"
      maskUnits="userSpaceOnUse"
      style={{maskType: 'luminance'}}
      width="32"
      x="0"
      y="0"
    >
      <path
        d="M16 0H16C7.16343 0 0 7.16342 0 16V16C0 24.8366 7.16343 32 16 32H16C24.8366 32 32 24.8366 32 16V16C32 7.16342 24.8366 0 16 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_14108_160427)">
      <path
        d="M15.9961 -0.00195312H15.9961C7.15952 -0.00195312 -0.00390625 7.16147 -0.00390625 15.998V15.9981C-0.00390625 24.8346 7.15952 31.998 15.9961 31.998H15.9961C24.8327 31.998 31.9961 24.8346 31.9961 15.9981V15.998C31.9961 7.16147 24.8327 -0.00195312 15.9961 -0.00195312Z"
        fill="black"
      />
      <mask
        height="44"
        id="mask1_14108_160427"
        maskUnits="userSpaceOnUse"
        style={{maskType: 'alpha'}}
        width="42"
        x="-10"
        y="-6"
      >
        <path
          d="M-8.11091 5.44226L9.86808 -5.13367C10.7299 -5.64066 11.7989 -5.64066 12.6608 -5.13367L30.64 5.44226C31.4812 5.9371 31.9976 6.84017 31.9976 7.8161V24.1794C31.9976 25.1552 31.4812 26.0583 30.64 26.5531L12.6608 37.1291C11.7989 37.636 10.7299 37.636 9.86808 37.1291L-8.11091 26.5531C-8.95211 26.0583 -9.46875 25.1552 -9.46875 24.1794V7.8161C-9.46875 6.84017 -8.95211 5.9371 -8.11091 5.44226Z"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask1_14108_160427)">
        <path
          d="M11.2644 -5.95337L-9.46875 6.24262L11.2644 18.4386L31.9976 6.24262L11.2644 -5.95337Z"
          fill="url(#paint0_linear_14108_160427)"
        />
        <path
          d="M-9.46875 25.756V6.2428L11.2644 18.4388V37.9524L-9.46875 25.756Z"
          fill="url(#paint1_radial_14108_160427)"
        />
        <path
          d="M31.9988 25.7565V6.2428L11.2656 18.4388V37.9524L31.9988 25.7565Z"
          fill="url(#paint2_radial_14108_160427)"
        />
        <path
          clipRule="evenodd"
          d="M0.628269 -3.69641L23.947 10.1688C24.4024 10.4396 24.6815 10.9303 24.6815 11.46V35.5123H18.5836V14.9287C18.5836 14.3989 18.3045 13.9083 17.8491 13.6375L-2.48828 1.54503L0.628269 -3.69641Z"
          fill="url(#paint3_radial_14108_160427)"
          fillRule="evenodd"
        />
      </g>
      <path
        clipRule="evenodd"
        d="M5.79803 5.49049L6.333 5.26184L8.4738 6.48127L9.46766 5.94776L7.32708 4.72833L7.86205 4.42347L4.42188 3.58511L5.79803 5.49049ZM8.32092 4.11862L8.85589 3.81376L10.9967 5.03319L12.0669 4.57591L9.9263 3.28025L10.4615 2.97539L7.02109 2.21326L8.32092 4.11862ZM8.39725 7.01478L12.9844 4.49968L13.443 4.80454L8.85589 7.31964L8.39725 7.01478Z"
        fill="black"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M13.7599 10.3622C12.5521 9.52982 12.7029 8.31913 13.9863 7.63812C15.2695 6.88144 17.3075 7.03277 18.4396 7.86513C19.4209 8.54613 19.3455 9.68114 19.5719 11.3459C19.5719 11.4972 19.4209 11.5729 19.1945 11.5729C17.2319 11.1945 14.9674 11.1189 13.7599 10.3622ZM17.0811 9.83249C17.6849 9.52982 17.6849 8.92446 17.1565 8.54613C16.628 8.16778 15.7223 8.09213 15.1184 8.47046C14.5146 8.77314 14.5146 9.37849 15.043 9.75682C15.5713 10.0595 16.4772 10.1352 17.0811 9.83249Z"
        fill="black"
        fillRule="evenodd"
      />
      <path
        d="M23.4545 13.6161L21.7053 14.5898L21.4958 15.2952L22.1468 14.9513L21.2733 17.4372L21.4958 15.6314L20.8685 15.9519L21.0511 14.9981L19.5742 15.8424C19.5796 16.0588 19.5965 16.6352 19.6218 17.2105C19.7014 19.204 20.8736 19.2356 21.2592 19.1909C21.2629 19.4552 21.3575 20.3711 21.1193 20.896C20.881 21.4209 20.4467 21.5578 20.0656 21.8233C19.861 21.9656 19.9709 22.2643 20.385 22.054C20.7991 21.8437 22.3013 20.9351 22.7973 20.6947C23.0513 20.5716 23.0896 20.2204 22.6854 20.4003C21.571 20.896 21.7053 20.0476 21.7053 19.7467C21.7053 19.4458 21.7006 19.3675 21.7053 19.0045C23.4167 16.7652 23.5846 14.4792 23.4545 13.6161Z"
        fill="black"
      />
      <path
        clipRule="evenodd"
        d="M19.5742 27.4859L20.0366 27.2558V29.8626L20.9615 29.326V26.7192L21.4239 26.489L20.4992 24.1123L19.5742 27.4859ZM21.8094 26.2591L22.2718 26.029V28.6359L23.1967 28.0993V25.4924L23.6593 25.2623L22.6571 22.8088L21.8094 26.2591ZM19.5742 30.7061L23.5821 28.406V29.0193L19.5742 31.3195V30.7061Z"
        fill="black"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_14108_160427"
        x1="10.4351"
        x2="11.8087"
        y1="-4.6362"
        y2="14.7858"
      >
        <stop stopColor="#FFE7C2" />
        <stop offset="1" stopColor="#E3B673" />
      </linearGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(10.3573 36.4884) rotate(-130.069) scale(22.949 21.5014)"
        gradientUnits="userSpaceOnUse"
        id="paint1_radial_14108_160427"
        r="1"
      >
        <stop stopColor="#CA8D32" />
        <stop offset="1" stopColor="#F2C888" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(5.65982 29.9026) rotate(-27.4023) scale(26.2337 23.7075)"
        gradientUnits="userSpaceOnUse"
        id="paint2_radial_14108_160427"
        r="1"
      >
        <stop stopColor="#C4892F" />
        <stop offset="1" stopColor="#E6BE81" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(-2.14981 1.97334) rotate(30.7627) scale(29.8054 21.8208)"
        gradientUnits="userSpaceOnUse"
        id="paint3_radial_14108_160427"
        r="1"
      >
        <stop stopColor="#FFF6E8" />
        <stop offset="0.677761" stopColor="#FFF9EF" />
        <stop offset="1" stopColor="#F0DBBC" />
      </radialGradient>
    </defs>
  </>,
  'DostavkaLogoCollapsed',
  {className: root, viewBox: '0 0 32 32'},
)
